var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3DView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8867 3.7866L8.70667 1.53327C8.26667 1.29327 7.73333 1.29327 7.29333 1.53327L3.11333 3.7866C2.80667 3.95327 2.62 4.27327 2.62 4.63994C2.62 4.99994 2.80667 5.3266 3.11333 5.49327L7.29333 7.74661C7.51333 7.86661 7.76 7.92661 8 7.92661C8.24 7.92661 8.48667 7.86661 8.70667 7.74661L12.8867 5.49327C13.1933 5.3266 13.38 5.00661 13.38 4.63994C13.38 4.27327 13.1933 3.95327 12.8867 3.7866Z",
    fill: "#717680"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60667 8.52675L2.71333 6.58008C2.41333 6.43341 2.06667 6.44675 1.78667 6.62008C1.5 6.80008 1.33333 7.10008 1.33333 7.43341V11.1067C1.33333 11.7401 1.68667 12.3134 2.25333 12.6001L6.14 14.5467C6.27333 14.6134 6.42 14.6467 6.56667 14.6467C6.74 14.6467 6.91333 14.6001 7.06667 14.5067C7.35333 14.3334 7.52 14.0267 7.52 13.6934V10.0201C7.52667 9.38008 7.17333 8.80675 6.60667 8.52675Z",
    fill: "#717680"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2133 6.62009C13.9267 6.44676 13.58 6.42676 13.2867 6.58009L9.4 8.52676C8.83333 8.81343 8.48 9.38009 8.48 10.0201V13.6934C8.48 14.0268 8.64667 14.3334 8.93333 14.5068C9.08667 14.6001 9.26 14.6468 9.43333 14.6468C9.58 14.6468 9.72667 14.6134 9.86 14.5468L13.7467 12.6001C14.3133 12.3134 14.6667 11.7468 14.6667 11.1068V7.43343C14.6667 7.10009 14.5 6.80009 14.2133 6.62009Z",
    fill: "#717680"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DView);
export default __webpack_public_path__ + "static/media/3dView.e533f6ab294e535dda836066b311f668.svg";
export { ForwardRef as ReactComponent };